import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: 'transparent',
    padding: 0,
  },
  listItem: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: 14,
    padding: theme.spacing(1.8),
    marginBottom: theme.spacing(1),
    boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0 4px 14px rgba(0,0,0,0.10)',
      transform: 'translateY(-1px)',
      backgroundColor: theme.palette.action.hover,
    },
  },
  avatar: {
    width: 52,
    height: 52,
    borderRadius: 12,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    fontSize: '1rem',
    marginRight: theme.spacing(2.5),
    flexShrink: 0,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  primaryText: {
    fontWeight: 600,
    fontSize: '0.90rem',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  secondaryText: {
    fontSize: '0.80rem',
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));

export default function AccionesRapidasMentora({
  imagen,
  titulo,
  sub_titulo,
  des_sub_titulo,
  avatar = '',
  avatar_name = '',
  list_desc = [],
  altura = {},
}) {
  const classes = useStyles();

  return (
    <List className={classes.root}>
      <ListItem button className={classes.listItem}>
        <ListItemAvatar>
          {imagen && !avatar ? (
            <Avatar alt="" src={imagen} className={classes.avatar} />
          ) : (
            <Avatar
              alt=""
              className={classes.avatar}
              style={avatar || {}}
            >
              {avatar_name}
            </Avatar>
          )}
        </ListItemAvatar>
        <Box className={classes.content} style={altura}>
          <Typography className={classes.primaryText}>
            {titulo}
          </Typography>
          {sub_titulo && (
            <Typography className={classes.secondaryText} color="textSecondary">
              {sub_titulo}
            </Typography>
          )}
          {des_sub_titulo && (
            <Typography className={classes.secondaryText} color="textSecondary">
              {des_sub_titulo}
            </Typography>
          )}
          {list_desc.map((text, i) => (
            <Typography
              key={i}
              className={classes.secondaryText}
              color="textSecondary"
            >
              {text}
            </Typography>
          ))}
        </Box>
      </ListItem>
    </List>
  );
}